import { render, staticRenderFns } from "./user-menu.vue?vue&type=template&id=5f291951&scoped=true&"
import script from "./user-menu.vue?vue&type=script&lang=ts&"
export * from "./user-menu.vue?vue&type=script&lang=ts&"
import style0 from "./user-menu.vue?vue&type=style&index=0&id=5f291951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f291951",
  null
  
)

export default component.exports